import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
  Link,
  Box
} from '@mui/material';

const TermsAcceptance = ({ onAccept }) => {
  const [open, setOpen] = useState(false);
  const [accepted, setAccepted] = useState(false);
  
  // Check if user has already accepted terms
  useEffect(() => {
    const hasAccepted = localStorage.getItem('termsAccepted');
    if (!hasAccepted) {
      setOpen(true);
    } else {
      // If already accepted, call the onAccept callback immediately
      onAccept();
    }
  }, [onAccept]);
  
  const handleAccept = () => {
    localStorage.setItem('termsAccepted', 'true');
    localStorage.setItem('termsAcceptedDate', new Date().toISOString());
    setOpen(false);
    onAccept();
  };
  
  return (
    <Dialog 
      open={open} 
      fullWidth 
      maxWidth="sm"
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          setOpen(false);
        }
      }}
    >
      <DialogTitle align="center">
        Terms of Service
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          This calculator is for entertainment purposes only and should not be used for making financial decisions.
        </Typography>
        
        <Typography variant="body2" sx={{ mb: 2 }}>
          By using this tool, you acknowledge that calculations may contain errors, and agree not to rely on them for financial or career decisions.
        </Typography>
        
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Link 
            href="/terms-of-service.html" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            View Full Terms of Service
          </Link>
        </Box>
        
        <FormControlLabel
          sx={{ 
            display: 'flex', 
            justifyContent: 'center',
            '& .MuiCheckbox-root': { 
              padding: '12px' // Larger touch target for mobile
            }
          }}
          control={
            <Checkbox 
              checked={accepted} 
              onChange={(e) => setAccepted(e.target.checked)}
              color="primary"
              size="medium"
            />
          }
          label={
            <Typography>
              I agree to the Terms of Service
            </Typography>
          }
        />
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button 
          onClick={handleAccept} 
          color="primary" 
          variant="contained"
          disabled={!accepted}
          size="large"
          sx={{ minWidth: '150px' }}
        >
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsAcceptance; 